<template>
  <div class="circle">
    <div class="header">
      <p>{{titles}}人数统计图(人)</p>
      <p v-show="shows">(点击下图可查看男女党员年龄阶段人数图)</p>
      <button v-show="!shows" @click="back">返回上图</button>
    </div>
    <div id="main"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echarts: require("echarts"),
      shows: true,
      myChart: "",
      titles:"男女党员",
      option: {
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        series: [
          {
            type: "pie",
            radius: "65%",
            center: ["50%", "50%"],
            selectedMode: "single"
          }
        ]
      },
    };
  },
  methods: {
    circle() {
      this.option.series[0].data = this.datas;     
      this.myChart.setOption(this.option);
    },
    click() {      
      this.myChart.on("click", (e) => {
        this.shows = false;
        this.titles = e.name
        this.$emit("change", "type",e.name);
      });
    },
    back() {
      this.shows = true;
      this.titles = '男女党员'
      this.$emit("change", "back");
    }
  },
  mounted: function() {
    let bar_dv = document.getElementById("main");
    this.myChart = this.echarts.init(bar_dv);
    this.circle();
    this.click();//添加事件
  },
  name: "pictures",
  props: {
    title: String,
    datas: Array
  },
  watch: {
    datas: function() {
      this.circle();
    }
  }
};
</script>
<style lang='scss' scoped>
.circle {
  #main {
    width: 100%;
    height: 4rem;
  }
  .header {
    button {
      font-size: 0.28rem;
      color: #fff;
      border: none;
      padding: 0.1rem 0.2rem;
      border-radius: 0.08rem;
      background-image: linear-gradient(113deg, #facb4c 0%, #fab808 100%);
    }
    p {
      &:nth-child(2) {
        color: #999999;
      }
    }
    line-height: 2;
    padding: 0.3rem 0;
    text-align: center;
  }
  background: #fff;
}
</style>